"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useMarkAllAsAcknowledged;

var _useContext = _interopRequireDefault(require("./private/useContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useMarkAllAsAcknowledged() {
  return (0, _useContext.default)().markAllAsAcknowledged;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VNYXJrQWxsQXNBY2tub3dsZWRnZWQiLCJ1c2VBY3Rpdml0eUFja25vd2xlZGdlbWVudENvbnRleHQiLCJtYXJrQWxsQXNBY2tub3dsZWRnZWQiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9wcm92aWRlcnMvQWN0aXZpdHlBY2tub3dsZWRnZW1lbnQvdXNlTWFya0FsbEFzQWNrbm93bGVkZ2VkLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VBY3Rpdml0eUFja25vd2xlZGdlbWVudENvbnRleHQgZnJvbSAnLi9wcml2YXRlL3VzZUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VNYXJrQWxsQXNBY2tub3dsZWRnZWQoKTogKCkgPT4gdm9pZCB7XG4gIHJldHVybiB1c2VBY3Rpdml0eUFja25vd2xlZGdlbWVudENvbnRleHQoKS5tYXJrQWxsQXNBY2tub3dsZWRnZWQ7XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7OztBQUVlLFNBQVNBLHdCQUFULEdBQWdEO0VBQzdELE9BQU8sSUFBQUMsbUJBQUEsSUFBb0NDLHFCQUEzQztBQUNEIn0=